<template>

  <ContentsProductHighPerformancePageTitle title="PEI (Polyetherimide)" />

  <section class="section-product-detail-page" >
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/high-performance-plastics/pei01.jpg"
            credit="photo credit : https://knowledge.ulprospector.com"
            :contents="[
              'PEI or Ultem™ is amorphous polymer and is one of the highest heat plastics among transparent materials. Its outstanding advantages are high heat resistance (Tg 217-247c, RTI 180c), good chemical resistance except strong base, low CTE, low shrinkage, lightweight (Sg 1.27), high strength at elevated temperature, inherent flame retardancy, and IR transparency.',
            ]"
            :is-reverse="true"
            :is-content-small-text="true"
            left-width="43.444%"
            right-width="56.252%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/high-performance-plastics/pei02.jpg"
            :contents="[
              'With its unique properties, PEI is used in applications where requirements are stringent such as high precision parts with tight tolerance or metal replacement, and in harsh environments such as hot and cold temperature, strong chemical exposure. PEI is well known for glasses frame because of its lightweight and high strength, hard disk drive components, 5G antenna, ADAS lenses, fuel pump, throttle body for automotive, valves in fluid engineering, food service, interior mass transportation cabin due to FST requirements, medical equipment that require maximum sterilization, and thin wall parts where strength is needed',
            ]"
            :is-content-small-text="true"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :partners="[
            {
              name: 'Sabic',
              image: {
                width: 272,
                height: 145,
                src: '/pages/products/high-performance-plastics/Screen-Shot-2565-05-19-at-15.08.54.png',
              }
            }
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'pei - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>

.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>